import React from 'react'
import '../styles/layout/Home.css'
import { Link } from 'react-router-dom'
import { Container } from 'react-bootstrap';
import EastRoundedIcon from '@mui/icons-material/EastRounded';
import HeroArt from './HeroArt'

const Banner = () => {
  return (
    <section className="hero grain">
      <span className="aurora" aria-hidden="true" />
      <span className="grid-field" aria-hidden="true" />

      <Container className="hero__container">
        <div className="hero__copy">
          <h2>
            Make Your Bank <span className="gradient-text">Everyone’s Choice</span> For Credit Cards
          </h2>
          <p>Increase your customer lifetime value with credit cards</p>
          <Link to="/contact" className="btn-42 btn-42--primary hero__cta">
            Get Started
            <EastRoundedIcon fontSize="small" />
          </Link>
        </div>

        <div className="hero__showcase" aria-hidden="true">
          <div className="hero__frame">
            <HeroArt />
          </div>
        </div>
      </Container>
    </section>
  )
}

export default Banner
